(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lu26-brand-film"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFilm(root) {
      if (!root || root.dataset.lu26FilmReady) return;
      root.dataset.lu26FilmReady = '1';
      if (root.dataset.autoplay !== 'true') return;
      if (!('IntersectionObserver' in window)) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var v = en.target;
          if (en.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
          else { v.pause(); }
        });
      }, { threshold: 0.6 });
      root.querySelectorAll('video').forEach(function (v) { io.observe(v); });
    }
    function initYT(scope) {
      (scope || document).querySelectorAll('[data-lu26-yt]').forEach(function (m) {
        if (m.dataset.ytReady) return; m.dataset.ytReady = '1';
        var media = m.closest('.lu26-film__slide').querySelector('.lu26-film__media');
        function load() {
          if (media.querySelector('iframe')) return;
          var f = document.createElement('iframe');
          f.src = m.dataset.lu26Yt; f.title = m.dataset.title || 'Video';
          f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen'; f.setAttribute('allowfullscreen', '');
          f.addEventListener('load', function () { setTimeout(function () { f.classList.add('is-ready'); }, 700); });
          media.appendChild(f);
        }
        if (!('IntersectionObserver' in window)) { load(); return; }
        var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { load(); io.disconnect(); } }, { rootMargin: '200px 0px' });
        io.observe(media);
      });
    }
    function all(scope) { (scope || document).querySelectorAll('[data-lu26-film]').forEach(initFilm); initYT(scope); }
    if (document.readyState !== 'loading') all(); else document.addEventListener('DOMContentLoaded', function () { all(); });
    document.addEventListener('shopify:section:load', function (e) { all(e.target); });

    document.addEventListener('click', function (e) {
      var ys = e.target.closest('[data-lu26-yt-sound]');
      if (ys) {
        var fr = ys.closest('.lu26-film__slide').querySelector('.lu26-film__media iframe');
        if (!fr) return;
        var on = !ys.classList.contains('is-on');
        fr.contentWindow.postMessage(JSON.stringify({ event: 'command', func: on ? 'unMute' : 'mute', args: [] }), '*');
        if (on) fr.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'playVideo', args: [] }), '*');
        ys.classList.toggle('is-on', on);
        ys.setAttribute('aria-label', on ? 'Äänet pois' : 'Äänet päälle');
        return;
      }
      var sound = e.target.closest('[data-lu26-film-sound]');
      if (sound) {
        var slide = sound.closest('.lu26-film__slide');
        var v = slide && slide.querySelector('video');
        if (!v) return;
        v.muted = !v.muted;
        if (!v.muted) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        sound.classList.toggle('is-on', !v.muted);
        sound.setAttribute('aria-label', v.muted ? 'Äänet päälle' : 'Äänet pois');
        return;
      }
      var play = e.target.closest('[data-lu26-film-embed]');
      if (play) {
        var s = play.closest('.lu26-film__slide');
        var media = s.querySelector('.lu26-film__media');
        var frame = document.createElement('iframe');
        frame.src = play.dataset.lu26FilmEmbed;
        frame.title = play.getAttribute('aria-label') || 'Video';
        frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        frame.setAttribute('allowfullscreen', '');
        media.appendChild(frame);
        s.classList.add('is-playing');
        play.remove();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lu26-brand-videos"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initVids(root) {
      if (!root || root.dataset.lu26Ready) return;
      root.dataset.lu26Ready = '1';
      var auto = root.dataset.autoplay === 'true';
      var vids = root.querySelectorAll('video');
      if (auto && 'IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            var v = en.target;
            if (en.isIntersecting) { v.preload = 'auto'; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
            else { v.pause(); }
          });
        }, { threshold: 0.6 });
        vids.forEach(function (v) { io.observe(v); });
      }
    }
    function initAll() { document.querySelectorAll('[data-lu26-vids]').forEach(initVids); }
    if (document.readyState !== 'loading') initAll(); else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', function (e) { initVids(e.target.querySelector('[data-lu26-vids]')); });

    document.addEventListener('click', function (e) {
      var sound = e.target.closest('[data-lu26-sound]');
      if (sound) {
        var v = sound.parentElement.querySelector('video');
        if (!v) return;
        document.querySelectorAll('[data-lu26-vids] video').forEach(function (o) { if (o !== v) { o.muted = true; var b = o.parentElement.querySelector('[data-lu26-sound]'); if (b) b.classList.remove('is-on'); } });
        v.muted = !v.muted;
        if (!v.muted) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        sound.classList.toggle('is-on', !v.muted);
        sound.setAttribute('aria-label', v.muted ? 'Äänet päälle' : 'Äänet pois');
        return;
      }
      var tog = e.target.closest('[data-lu26-toggle]');
      if (tog) {
        var tv = tog.parentElement.querySelector('video');
        if (!tv) return;
        if (tv.paused) { tv.preload = 'auto'; var tp = tv.play(); if (tp && tp.catch) tp.catch(function () {}); } else { tv.pause(); }
        return;
      }
      var play = e.target.closest('[data-lu26-embed]');
      if (play) {
        var frame = document.createElement('iframe');
        frame.src = play.dataset.lu26Embed;
        frame.title = play.getAttribute('aria-label') || 'Video';
        frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        frame.setAttribute('allowfullscreen', '');
        play.parentElement.appendChild(frame);
        play.remove();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lu26-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-lu26-pause]');
    if (!btn) return;
    var section = btn.closest('.lu26-hero');
    var videos = section ? section.querySelectorAll('video') : [];
    var paused = btn.classList.toggle('is-paused');
    videos.forEach(function (v) { paused ? v.pause() : v.play(); });
    btn.setAttribute('aria-label', paused ? 'Toista video' : 'Pysäytä video');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lu26-product-ugc"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.pugcReady) return;
      root.dataset.pugcReady = '1';
      var vids = root.querySelectorAll('video');
      if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var v = en.target;
          if (en.isIntersecting) { v.preload = 'auto'; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
          else { v.pause(); }
        });
      }, { threshold: 0.6 });
      vids.forEach(function (v) { io.observe(v); });
    }
    function all() { document.querySelectorAll('[data-lu26-pugc]').forEach(init); }
    if (document.readyState !== 'loading') all(); else document.addEventListener('DOMContentLoaded', all);
    document.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('[data-lu26-pugc]')); });
    document.addEventListener('click', function (e) {
      var s = e.target.closest('[data-pugc-sound]');
      if (s) {
        var v = s.parentElement.querySelector('video');
        if (!v) return;
        document.querySelectorAll('[data-lu26-pugc] video').forEach(function (o) {
          if (o !== v) { o.muted = true; var b = o.parentElement.querySelector('[data-pugc-sound]'); if (b) b.classList.remove('is-on'); }
        });
        v.muted = !v.muted;
        if (!v.muted) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        s.classList.toggle('is-on', !v.muted);
        s.setAttribute('aria-label', v.muted ? 'Äänet päälle' : 'Äänet pois');
        return;
      }
      var t = e.target.closest('[data-pugc-toggle]');
      if (t) {
        var tv = t.parentElement.querySelector('video');
        if (tv) { if (tv.paused) { tv.play(); } else { tv.pause(); } }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
